import { render } from "./Pending-disposition.vue?vue&type=template&id=0447be23&scoped=true"
import script from "./Pending-disposition.vue?vue&type=script&lang=js"
export * from "./Pending-disposition.vue?vue&type=script&lang=js"

import "./Pending-disposition.vue?vue&type=style&index=0&id=0447be23&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0447be23"]])

export default __exports__